export const AppConfig = {
  DATE_FORMAT: 'dd/MM/yyyy',
  DATE_TIME_FORMAT: 'dd/MM/yyyy HH:mm',
  DATE_TIME_SEC_FORMAT: 'dd/MM/yyyy HH:mm:ss',
  TIME_FORMAT: 'HH:mm',
  TIME_SEC_FORMAT: 'HH:mm:ss',
  NUMBER_REGEX: '^-?[0-9]{1,9}(?:\\.[0-9]{1,3})?$',
  NUMBER_FORMAT: '1.0-2',
  MAX_DECIMAL: 2,
  LOADING_TEXT: 'Loading...',
  ENCR_DECR_KEY: 'xpF8dCDpNRzjm4toSuDPtg==',
  LOADING: true,
  URL_PARAM_TYPE: ';',
  CALENDAR_FORMAT: 'dd/mm/yy',
  URL_REGEX:
    '[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)',
};
